import React from 'react';

import { cn } from '@change/ds-utils';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { RectangleShapeStyles, SkeletonContainerStyles } from './Header.styles';
import { TextSkeleton1Styles, TextSkeleton2Styles, TextSkeletonContainerStyles } from './HeaderTextSkeletons.styles';
import type { InstagramPostComponentsProps } from './types';

export const Header: React.FC<InstagramPostComponentsProps> = (props) => {
	const { loading, size, retryState } = props;

	if (size === 'xsmall' && loading) {
		return null;
	}

	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = loading && retryState !== 'failed';

	/*
		I'm experimenting with using a config const file instead of tv styles. Since we need to support 3 sizes that are
		different to the usual responsive sizes, it becomes cumbersome to manage with tv styles since we would need to
		create and export a styles block for each of the rectangles used in the skeleton.
	 */
	const rectangleStyles = RectangleShapeStyles({ size });

	return (
		<SkeletonContainer loading={shouldAnimate} shapeSize={size} className={SkeletonContainerStyles({ size })}>
			<Circle />
			<div className={TextSkeletonContainerStyles({ size })}>
				<Rectangle className={cn(rectangleStyles, TextSkeleton1Styles({ size }))} rounded />
				<Rectangle className={cn(rectangleStyles, TextSkeleton2Styles({ size }))} rounded />
			</div>
		</SkeletonContainer>
	);
};
